import React, { useState, useEffect } from 'react';

interface SearchInputProps {
  onSearch: (term: string) => void;
  isLoading: boolean;
  initialValue?: string;
}

export const SearchInput: React.FC<SearchInputProps> = ({ onSearch, isLoading, initialValue = '' }) => {
  const [term, setTerm] = useState(initialValue);

  useEffect(() => {
    if (initialValue !== undefined && initialValue !== term) {
      setTerm(initialValue);
    }
    // Sincroniza apenas quando initialValue (vindo da URL) muda; incluir `term`
    // aqui reintroduziria um loop com o efeito de debounce abaixo.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initialValue]);

  const sanitizeTerm = (input: string) => {
    return input.replace(/,\s+/g, ',').trim();
  };

  useEffect(() => {
    const sanitized = sanitizeTerm(term);
    if (sanitized !== '' && sanitized.length < 3) return;

    const timer = setTimeout(() => {
      onSearch(sanitized);
    }, 600);

    return () => clearTimeout(timer);
  }, [term, onSearch]);

  const handleClear = () => {
    setTerm('');
    onSearch('');
  };

  return (
    <div className="relative w-full max-w-3xl mx-auto">
      <div className="relative group">
        <div className="absolute inset-y-0 left-0 flex items-center pl-4 pointer-events-none">
          <svg className={`w-6 h-6 ${isLoading ? 'text-brand-500 animate-spin' : 'text-gray-400 group-focus-within:text-brand-500 transition-colors'}`} fill="none" viewBox="0 0 24 24" stroke="currentColor">
            {isLoading ? (
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
            ) : (
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
            )}
          </svg>
        </div>
        <input
          type="text"
          className="block w-full p-4 pl-12 text-lg text-gray-900 border border-gray-200 rounded-full bg-white shadow-lg focus:ring-4 focus:ring-brand-100 focus:border-brand-500 outline-none transition-all placeholder-gray-400"
          placeholder="Endereço"
          value={term}
          onChange={(e) => setTerm(e.target.value)}
        />
        {term && (
          <button
            onClick={handleClear}
            className="absolute inset-y-0 right-0 flex items-center pr-4 text-gray-400 hover:text-gray-600 cursor-pointer"
          >
            <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        )}
      </div>
      <div className="text-center mt-2 flex flex-wrap justify-center gap-x-6 gap-y-1">
        <span className="text-[10px] text-gray-400 uppercase font-bold tracking-widest">
          Slug: "-" para espaços e "," visível
        </span>
        <span className="text-[10px] text-brand-600 uppercase font-bold tracking-widest">
          Auto-ajuste: "Paulista, 1000" → "Paulista,1000"
        </span>
      </div>
    </div>
  );
};